import { ArrowUpDown, Search } from 'lucide-react'
import { Button } from '../../../components/ui/button'
import { Input } from '../../../components/ui/input'
import { SupportCategoryEnum } from '@/app/utils/supportCategoryEnum'

interface SearchFiltersProps {
  selectedFilters: SupportCategoryEnum[]
  onFilterChange: (filters: SupportCategoryEnum[]) => void
  searchValue: string
  onSearchChange: (value: string) => void
}

export function SearchFilters({
  selectedFilters,
  onFilterChange,
  searchValue,
  onSearchChange,
}: SearchFiltersProps) {
  const handleFilterClick = (filter: SupportCategoryEnum) => {
    if (filter === SupportCategoryEnum.ALL) {
      onFilterChange([SupportCategoryEnum.ALL])
      return
    }

    let newFilters: SupportCategoryEnum[]

    if (selectedFilters.includes(SupportCategoryEnum.ALL)) {
      newFilters = [filter]
    } else {
      if (selectedFilters.includes(filter)) {
        newFilters = selectedFilters.filter((f) => f !== filter)
      } else {
        newFilters = [...selectedFilters, filter]
      }
    }

    if (newFilters.length === 0) {
      newFilters = [SupportCategoryEnum.ALL]
    }

    onFilterChange(newFilters)
  }

  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="space-y-4">
        <div className="flex flex-wrap gap-2">
          <Button
            variant={
              selectedFilters.includes(SupportCategoryEnum.ALL)
                ? 'default'
                : 'outline'
            }
            size="sm"
            onClick={() => handleFilterClick(SupportCategoryEnum.ALL)}
            className="flex items-center gap-2 rounded-full"
          >
            Todos
          </Button>
          <Button
            variant={
              selectedFilters.includes(SupportCategoryEnum.USER)
                ? 'default'
                : 'outline'
            }
            size="sm"
            onClick={() => handleFilterClick(SupportCategoryEnum.USER)}
            className="flex items-center gap-2 rounded-full"
          >
            <i className="fa-solid fa-chalkboard-user" />
            Vendedor
          </Button>
          <Button
            variant={
              selectedFilters.includes(SupportCategoryEnum.CUSTOMER)
                ? 'default'
                : 'outline'
            }
            size="sm"
            onClick={() => handleFilterClick(SupportCategoryEnum.CUSTOMER)}
            className="flex items-center gap-2 rounded-full"
          >
            <i className="fa-solid fa-user" />
            Clientes
          </Button>
          <Button
            variant={
              selectedFilters.includes(SupportCategoryEnum.TRANSACTION)
                ? 'default'
                : 'outline'
            }
            size="sm"
            onClick={() => handleFilterClick(SupportCategoryEnum.TRANSACTION)}
            className="flex items-center gap-2 rounded-full"
          >
            <ArrowUpDown className="h-5 w-5" />
            Transações
          </Button>
        </div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-6 w-6 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Pesquisar"
            className="rounded-full pl-10"
          />
        </div>
      </div>
    </div>
  )
}
